import vietnam from "../../resources/locales/vi/common.json"
import english from "../../resources/locales/en/common.json"
import home_vi from "../../resources/locales/vi/home.json"
import home_en from "../../resources/locales/en/home.json"
import about_vi from "../../resources/locales/vi/about.json"
import about_en from "../../resources/locales/en/about.json"
import news_vi from "../../resources/locales/vi/news.json"
import news_en from "../../resources/locales/en/news.json"
import contact_vi from "../../resources/locales/vi/contact.json"
import contact_en from "../../resources/locales/en/contact.json"
const languages = ["vi", "en"] as const
export const supportedLanguages = [...languages]
export type Language = (typeof languages)[number]

export type Resource = {
  common: typeof vietnam
  home: typeof home_vi
  about: typeof about_vi
  news: typeof news_vi
  contact: typeof contact_vi
}
export type Namespace = keyof Resource


export const resources: Record<Language, Resource> = {
  en: {
    common: english,
    home: home_en,
    about: about_en,
    news: news_en,
    contact: contact_en
  },
  vi: {
    common: vietnam,
    home: home_vi,
    about: about_vi,
    news: news_vi,
    contact: contact_vi
  },
}


declare module "i18next" {
  export interface CustomTypeOptions {
    defaultNS: "common"
    fallbackNS: "common"
    // custom resources type
    resources: Resource
  }
}
